import { useMemo } from "react"

import { Step, StepLabel, Stepper } from "@mui/material"
import { useTranslation } from "react-i18next"

type PageContainerStepperProps = {
  activeStep: number | undefined
  isTicketProductType: boolean
  isSummer?: boolean
}

const PageContainerStepper = ({
  activeStep,
  isTicketProductType,
  isSummer = false,
}: PageContainerStepperProps) => {
  const { t } = useTranslation()

  const steps = useMemo(() => {
    const stepArray = [{ key: "pass", label: t("stepper.pass") }]

    if (!isTicketProductType) {
      stepArray.push({
        key: "passHolderDetails",
        label: t("stepper.passHolderDetails", {
          context: isSummer ? "summer" : undefined,
        }),
      })
    }

    stepArray.push({ key: "cart", label: t("stepper.cart") })

    return stepArray
  }, [isTicketProductType, isSummer, t])

  if (activeStep === undefined) return null

  return (
    <Stepper activeStep={activeStep}>
      {steps.map((step, index) => (
        <Step
          key={step.key}
          aria-current={activeStep === index ? "step" : undefined}
        >
          <StepLabel>{step.label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}

export default PageContainerStepper
